import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Container,
  Button,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import moment from 'moment';
import SaveIcon from '@material-ui/icons/Save';
import { FixedWidthParser } from 'fixed-width-parser';
import GetAppIcon from '@material-ui/icons/GetApp';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { useParams, useNavigate } from 'react-router-dom';
import Controls from '../controls/Controls';
import { useConstantsContext } from '../../context/constants_context';
import { baseUrl, ssbFileCode } from '../../utils/constants';
import SsbProcessDetails from './SsbProcessDetails';
import SsbProcessLine from './SsbProcessLine';

export default function SsbProcess() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    refId: 0,
    createdDate: '',
    created: false,
    posted: false,
    errorsPosted: false,
    description: '',
    payeeCode: '',
    cycleId: 0,
    processSuccess: false,
    processErrors: false
  });
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [openPopup, setOpenPopup] = useState(false);
  const [begDate, setBegDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [responseDetails, setResponseDetails] = useState([]);
  const { payCycles } = useConstantsContext();
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });

  const SubmissionSchema = Yup.object().shape({
    // subjectcode: Yup.string().required('Province is required'),
    // nameofsubject: Yup.string().required('Province is required')
  });

  useEffect(() => {
    console.log('id is here', id);
    if (id > 0) {
      console.log('id is here 2', id);
      getSubmissionDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('id is again', formData);
  }, [formData]);

  formData.createdDate = moment(formData.createdDate).format('yyyy-MM-DD');

  const formik = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema: SubmissionSchema,
    onSubmit: (values) => {
      console.log('custingo before that exe 2', values);
      saveSsbProcess(values);
    }
  });

  const saveSsbProcess = (e) => {
    const jsonClient = [];
    jsonClient.push(e);
    console.log('student stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/saveSsbProcess`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setFormData(result);
          navigate('/accounts/selectssb');
          console.log('returned Submissions', result);
          setLoading(false);
          notifyPopup(`Submissions Updated Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in saving Submissions!: ${error}`, 'error');
        }
      );
  };

  const processCreateSubmission = (e) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    console.log('post submission', e);
    const jsonClient = [];
    jsonClient.push(e);
    console.log('bulk receipt stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/accounting/ProcessBulkBillDetails?billNo=${e.id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          getSubmissionDetail();
          console.log('returned Submissions bulk', result);
          setLoading(false);
          notifyPopup(`Submissions Details Updated Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Processing Bulk Receipt Details!: ${error}`, 'error');
        }
      );
  };

  const getSubmissionDetail = async () => {
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetSsbProcess?refId=${id}`).then(
      (res) => {
        setLoading(false);
        console.log('returned SsbProcess aatt', res);
        setFormData(res.data.result);
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const createSsbFile = async (currentCode) => {
    const filename = `${formik.values.payeeCode}_${moment().format('DD-MMM-YYYY')}.txt`;
    setLoading(true);
    fetch(`${baseUrl}/api/client/WriteSsbSubmissionFile?payeeCode=${currentCode}&refId=${id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Claims by Department!: ${error}`, 'error');
        }
      );
  };

  const sendSsbFile = async (e) => {
    setLoading(true);
    const addresses = ['thandazanek@gmail.com', 'hoveterrence@gmail.com'];

    setLoading(true);
    const jsonClient = [];
    jsonClient.push(addresses);
    fetch(`${baseUrl}/api/client/SendSsbValidations?ssbFileId=${id}&fileName=ssb33333`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('from save SSB record', result);
          getSubmissionDetail();
          // navigate(`-1`);
          notifyPopup(`SSB Record Sent Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          console.log('returned error', error);
          notifyPopup(
            `Error in Creating SSB Record.  Please check the input fields..!: ${error}`,
            'error'
          );
        }
      );
  };

  const processResponses = async (e) => {
    setLoading(true);
    await axios.post(`${baseUrl}/api/client/ImportResponseFile`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in ImportResponseFile!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned doc', result);
          notifyPopup(`SSB Responses Processed Successfully!`, 'success');
          navigate('/dashboard', { replace: true });
        }
      },
      (error) => {
        notifyPopup(`Error in ImportResponseFile..File not created!: ${error}`, 'error');
      }
    );
  };

  // --------------------------------------Handle Success Import
  const handleSuccessImport = (e) => {
    setLoading(true);
    setResponseDetails([]);
    const { files } = e.target;

    if (files.length) {
      const file = files[0];
      console.log('file contents', file);
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result;
        console.log('text', text);
        // alert(text)
        downloadDocument(text, file.name);
      };
      reader.readAsText(e.target.files[0]);
    }
    setLoading(false);
  };

  const downloadDocument = (e, filename) => {
    const fixedWidthParser = new FixedWidthParser([
      {
        name: 'ecNumber',
        start: 0,
        width: 8
      },
      {
        name: 'transactionType',
        start: 8,
        width: 1
      },
      {
        type: 'date',
        name: 'fromDate',
        start: 75,
        width: 10,
        jsonFormat: 'yyyy-MM-dd',
        fixedWidthFormat: 'dd/MM/yyyy'
      },
      {
        type: 'date',
        name: 'toDate',
        start: 86,
        width: 10,
        jsonFormat: 'yyyy-MM-dd',
        fixedWidthFormat: 'dd/MM/yyyy'
      },
      {
        name: 'amount',
        start: 96,
        width: 14
      },
      {
        name: 'branchCode',
        start: 111,
        width: 7
      },
      {
        name: 'bankAccountNumber',
        start: 119,
        width: 20
      }
    ]);

    const result = fixedWidthParser.parse(e);
    result.forEach((data) => {
      data.fileType = filename;
      data.submissionId = id;
    });
    result.slice(6);
    result.pop(3);
    const numberoflines = result.length - 2;
    const filtered = result.slice(6, numberoflines);

    setResponseDetails(filtered);
    console.log('result2 is', result);
    console.log('filtered is', filtered);
    updateTariffCost(filtered);
  };

  // --------------------------------------Handle Errors Import
  const handleFailureImport = (e) => {
    setLoading(true);
    setResponseDetails([]);
    const { files } = e.target;

    if (files.length) {
      const file = files[0];
      console.log('file contents', file);
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result;
        console.log('text', text);
        downloadErrorDocument(text, file.name);
      };
      reader.readAsText(e.target.files[0]);
    }
    setLoading(false);
  };

  const downloadErrorDocument = (e, filename) => {
    const fixedWidthParser = new FixedWidthParser([
      {
        name: 'ecNumber',
        start: 0,
        width: 8
      },
      {
        name: 'transactionType',
        start: 8,
        width: 1
      },
      {
        type: 'date',
        name: 'fromDate',
        start: 54,
        width: 10,
        jsonFormat: 'yyyy-MM-dd',
        fixedWidthFormat: 'dd/MM/yyyy'
      },
      {
        name: 'amount',
        start: 76,
        width: 15
      },
      {
        name: 'symptoms',
        start: 92,
        width: 52
      }
    ]);

    const result = fixedWidthParser.parse(e);
    result.forEach((data) => {
      data.fileType = filename;
      data.submissionId = id;
    });
    result.slice(6);
    result.pop(3);
    const numberoflines = result.length - 2;
    const filtered = result.slice(6, numberoflines);

    setResponseDetails(filtered);
    console.log('result2 is', result);
    console.log('filtered is', filtered);
    processSsbErrors(filtered);
  };

  // --------------------------------------End Errors Import

  const updateTariffCost = async (filtered) => {
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(filtered);
    console.log('filtered stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/ProcessSsbResponses`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned response', res);
          setLoading(false);
          notifyPopup(`SSB Errors Updated Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Running SSB Error Responses!: ${error}`, 'error');
        }
      );
  };

  const processSsbErrors = async (filtered) => {
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(filtered);
    console.log('filtered stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/ProcessSsbErrors`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned response', res);
          setLoading(false);
          notifyPopup(`SSB Error Responses Updated Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Running SSB Error Responses!: ${error}`, 'error');
        }
      );
  };

  const createSsbExcel = (refId) => {
    const filename = `${formData.description}.xls`;
    setLoading(true);
    fetch(
      `${baseUrl}/api/warehouse/get/SsbExcelSubmission/xls/${moment(begDate).format(
        'YYYY-MM-DD'
      )}/${moment(begDate).format('YYYY-MM-DD')}/0/0/${refId}/0/0`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Reports Creation!: ${error}`, 'error');
        }
      );
  };

  const closePopup = () => {
    setOpenPopup(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Card>
        <Typography variant="h6" gutterBottom>
          Process SSB...
        </Typography>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                  <Controls.Input name="refId" label="Process Id" disabled />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Controls.DateTime name="createdDate" label="Created Date" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="description" label="Description" />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Controls.SelectJson name="payeeCode" label="SSB Code" options={ssbFileCode} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="payCycleLbl">Stroke</InputLabel>
                    <Select
                      id="cycleId"
                      value={formik.values.cycleId}
                      name="cycleId"
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => {
                        formik.setFieldValue('cycleId', e.target.value);
                      }}
                    >
                      <MenuItem key="" value="">
                        Not Selected
                      </MenuItem>
                      {payCycles.map((item) => (
                        <MenuItem key={item.payCycleId} value={item.payCycleId}>
                          {moment(item.payDate).isValid()
                            ? moment(item.payDate).format('YYYY-MM-DD')
                            : ''}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.created} name="created" disabled />}
                    label="Created"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControlLabel
                    control={<Checkbox checked={formData.posted} name="posted" disabled />}
                    label="Report Posted"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={formData.errorsPosted} name="errorsPosted" disabled />
                    }
                    label="Errors Run"
                  />
                </Grid>

                <Grid
                  margin={2}
                  container
                  direction="row"
                  justifyContent="right"
                  alignItems="right"
                >
                  {formik.values.refId === 0 && (
                    <Grid item xs={12} sm={1} marginRight={1} mr={2}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="outlined"
                        startIcon={<SaveIcon />}
                        disabled={formik.values.refId > 0}
                      >
                        Save...
                      </Button>
                    </Grid>
                  )}
                  <Grid item xs={12} sm={1} marginRight={1} mr={2}>
                    <Button
                      fullWidth
                      type="button"
                      variant="outlined"
                      startIcon={<SaveIcon />}
                      onClick={() => createSsbExcel(formik.values.refId)}
                    >
                      Create Excel...
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={2} marginRight={1} mr={2}>
                    <Button
                      fullWidth
                      type="button"
                      variant="outlined"
                      startIcon={<GetAppIcon />}
                      disabled={formik.values.created || formik.values.refId <= 0}
                      onClick={() => createSsbFile(formik.values.payeeCode)}
                    >
                      Create File...
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={2} marginRight={1} mr={2}>
                    <Button
                      fullWidth
                      type="button"
                      variant="outlined"
                      startIcon={<GetAppIcon />}
                      disabled={formik.values.created || formik.values.refId <= 0}
                      onClick={() => sendSsbFile()}
                    >
                      Submit File...
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={2} marginRight={1} mr={2}>
                    <Button
                      fullWidth
                      component="label"
                      variant="outlined"
                      startIcon={<AutorenewIcon />}
                      sx={{ marginRight: '1rem' }}
                      disabled={formik.values.posted || formik.values.refId <= 0}
                    >
                      Run Report
                      <input type="file" hidden onChange={handleSuccessImport} />
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={2} marginRight={1} mr={2}>
                    <Button
                      fullWidth
                      component="label"
                      variant="outlined"
                      startIcon={<SyncProblemIcon />}
                      sx={{ marginRight: '1rem' }}
                      disabled={formik.values.errorsPosted || formik.values.refId <= 0}
                    >
                      Run Errors
                      <input type="file" hidden onChange={handleFailureImport} />
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={2} marginRight={1}>
                    <Button
                      fullWidth
                      component="label"
                      variant="outlined"
                      startIcon={<SyncProblemIcon />}
                      sx={{ marginRight: '1rem' }}
                      // disabled={formik.values.created || formik.values.refId <= 0}
                      onClick={() => setOpenPopup(true)}
                    >
                      Add Change
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
          {formData.refId > 0 && <SsbProcessDetails processNo={id} />}
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Controls.Popup title="Add Detail Line" openPopup={openPopup} setOpenPopup={setOpenPopup}>
            <SsbProcessLine
              closePopup={closePopup}
              refId={formData.refId}
              payeeCode={formData.payeeCode}
            />
          </Controls.Popup>
        </CardContent>
      </Card>
    </Container>
  );
}
